import axios from '../../axios/index.js';

export default {
    /**
     * Retrieves service appointment report information.
     *
     * @param reportId Service Appointment Report ID
     *
     * @returns {*}
     */
    getReport (reportId) {
        return axios.get('/api/v1/service-appointments/reports/' + reportId);
    },

    /**
     * Creates new or updates existing service appointment report.
     *
     * @param data Service appointment report data
     * @param appointmentId Service appointment ID
     * @param isSubmit Is Submit
     *
     * @returns {*}
     */
    createUpdateReport (data, appointmentId = null, isSubmit = false) {
        let formData = new FormData();

        formData.append('is_submit', isSubmit ? '1' : '0');

        if (Object.keys(data).length !== 0 && data.constructor === Object) {
            Object.keys(data).forEach(function (key) {
                if (data[key] !== null && typeof data[key].id !== 'undefined') {
                    formData.append(key + '_id', data[key].id);
                } else {
                    if (data[key] !== null && Array.isArray(data[key]) && data[key].length) {
                        for (let i = 0; i < data[key].length; i++) {
                            if (typeof data[key][i].file !== 'undefined') {
                                formData.append(key + '[' + i + ']', data[key][i].file);
                            } else {
                                switch (data[key][i].data_type) {
                                    case 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportReference':
                                        formData.append(key + '[' + i + ']', JSON.stringify({
                                            id: data[key][i].id,
                                            value: data[key][i].value,
                                        }));

                                        break;
                                    case 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportDamage':
                                        let damage = JSON.parse(JSON.stringify(data[key][i]));

                                        if (damage.damage_images.length) {
                                            for (let j = 0; j < damage.damage_images.length; j++) {
                                                damage.damage_images[j] = damage.damage_images[j].file;
                                            }
                                        }

                                        if (damage.cause_of_damages.length) {
                                            for (let j = 0; j < damage.cause_of_damages.length; j++) {
                                                damage.cause_of_damages[j] = {
                                                    id: damage.cause_of_damages[j].id,
                                                    value: damage.cause_of_damages[j].value,
                                                };
                                            }
                                        }

                                        if (damage.damages.length) {
                                            for (let j = 0; j < damage.damages.length; j++) {
                                                damage.damages[j] = {
                                                    id: damage.damages[j].id,
                                                    value: damage.damages[j].value,
                                                };
                                            }
                                        }

                                        if (damage.items.length) {
                                            for (let j = 0; j < damage.items.length; j++) {
                                                damage.items[j] = {
                                                    id: damage.items[j].id,
                                                    description: damage.items[j].description,
                                                    quantity: damage.items[j].quantity,
                                                };
                                            }
                                        }

                                        const positionFields = [
                                            'accessories',
                                            'fillers',
                                            'handles',
                                            'sashes',
                                            'horizontal_mullions',
                                            'vertical_mullions',
                                        ];

                                        for (let k = 0; k < positionFields.length; k++) {
                                            for (let l = 0; l < damage[positionFields[k]].length; l++) {
                                                damage[positionFields[k]][l] = {
                                                    id: damage[positionFields[k]][l].id,
                                                    name: damage[positionFields[k]][l].name,
                                                    value: damage[positionFields[k]][l].value,
                                                };
                                            }
                                        }

                                        delete damage.position;

                                        formData.append(key + '[' + i + ']', JSON.stringify(damage));

                                        break;
                                    case 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportTest':
                                        let test = JSON.parse(JSON.stringify(data[key][i]));

                                        if (test.test_images.length) {
                                            for (let j = 0; j < test.test_images.length; j++) {
                                                test.test_images[j] = test.test_images[j].file;
                                            }
                                        }

                                        formData.append(key + '[' + i + ']', JSON.stringify(test));

                                        break;
                                    case 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportReferral':
                                        const ref = JSON.parse(JSON.stringify(data[key][i]));

                                        if (ref.images.length) {
                                            for (let j = 0; j < ref.images.length; j++) {
                                                ref.images[j] = ref.images[j].file;
                                            }
                                        }

                                        formData.append(key + '[' + i + ']', JSON.stringify(ref));

                                        break;
                                    case 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportAdditionalNote':
                                        let note = JSON.parse(JSON.stringify(data[key][i]));

                                        if (note.images.length) {
                                            for (let j = 0; j < note.images.length; j++) {
                                                note.images[j] = note.images[j].file;
                                            }
                                        }
                                        formData.append(key + '[' + i + ']', JSON.stringify(note));

                                        break;
                                    case 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportTextWithImageField':
                                        let text = JSON.parse(JSON.stringify(data[key][i]));

                                        if (text.field_images.length) {
                                            for (let j = 0; j < text.field_images.length; j++) {
                                                text.field_images[j] = text.field_images[j].file;
                                            }
                                        }

                                        formData.append(key + '[' + i + ']', JSON.stringify(text));

                                        break;
                                    default:
                                        formData.append(key + '[' + i + ']', data[key][i]);

                                        break;
                                }
                            }
                        }
                    } else {
                        if (data[key] !== null && Array.isArray(data[key])) {
                            // A workaround for sending empty arrays
                            formData.append(key + '[]', null);
                        } else {
                            formData.append(key, data[key]);
                        }
                    }
                }
            });
        }

        if (!data.id) {
            return axios.post('/api/v1/service-appointments/reports/create/' + appointmentId, formData);
        }

        return axios.post('/api/v1/service-appointments/reports/' + appointmentId, formData);
    },

    /**
     * Submits service appointment report.
     *
     * @param appointmentId Service Appointment ID
     *
     * @returns {*}
     */
    submitReport (appointmentId) {
        return axios.post('/api/v1/service-appointments/reports/submit/' + appointmentId);
    },

    /**
     * Approves service appointment report.
     *
     * @param appointmentId Service Appointment ID
     *
     * @returns {*}
     */
    approveReport (appointmentId) {
        return axios.post('/api/v1/service-appointments/reports/approve/' + appointmentId);
    },

    /**
     * Declines service appointment report.
     *
     * @param appointmentId Service Appointment ID
     * @param reason Reason for declining
     *
     * @returns {*}
     */
    declineReport (appointmentId, reason) {
        return axios.post('/api/v1/service-appointments/reports/decline/' + appointmentId, { declined_reason: reason });
    },

    /**
     * Cancels service appointment report.
     *
     * @param appointmentId Service Appointment ID
     * @param reason Reason for canceling
     *
     * @returns {*}
     */
    cancelReport (appointmentId, reason) {
        return axios.post('/api/v1/service-appointments/reports/cancel/' + appointmentId, { canceled_reason: reason });
    },

    /**
     * Get service appointments report file upload URL.
     *
     * @param appointmentId Service Appointment ID
     * @param fileName File name
     *
     * @returns {*}
     */
    getUploadUrl (appointmentId, fileName) {
        return axios.get('/api/v1/service-appointments/reports/file-upload-url/' + appointmentId, {
            params: {
                file_name: fileName,
            },
        });
    },

    /**
     * Get service appointments report creation information.
     *
     * @param appointmentId Service Appointment ID
     *
     * @returns {*}
     */
    getCreateInformation (appointmentId) {
        return axios.get('/api/v1/service-appointments/reports/info/' + appointmentId);
    },

    /**
     * Get service appointment report damage example.
     *
     * @param appointmentId Service Appointment ID
     * @param qrCode QR Code
     *
     * @returns {*}
     */
    getDamageExample (appointmentId, qrCode = null) {
        return axios.get('/api/v1/service-appointments/reports/damage/example/' + appointmentId, {
            params: {
                qr_code: qrCode,
            },
        });
    },

    /**
     * Gets signed url for open PDF
     *
     * @param serviceAppointmentId Service Appointment ID
     *
     * @returns {*}
     */
    getOpenPdfUrl (serviceAppointmentId) {
        return axios.post(
            '/api/v1/service-appointments/reports/get-signed-url-for-pdf-download/' + serviceAppointmentId);
    },
};
